

export const getSessionStorage = (key: string): string|null => sessionStorage.getItem(key)

export const setSessionStorage = (key: string, value: string): void => sessionStorage.setItem(key, value)

export const getLocalStorage = (key: string): string|null => localStorage.getItem(key)

export const setLocalStorage = (key: string, value: string): void => localStorage.setItem(key, value)